export enum AudioSegment {
  A,
  B
}
